const numberAlignRight = () => ({
  style: {
    textAlign: 'right',
  },
})

const textBreakWord = (_, rowInfo) => ({
  style: {
    whiteSpace: rowInfo && 'normal',
    wordBreak: rowInfo && 'break-word',
  },
})

export default [
  {
    Header: 'FC',
    id: 'fulfillmentCenter.name',
    accessor: 'fulfillmentCenter.name',
    width: 140,
    getProps: textBreakWord,
  },
  {
    Header: 'Tipo',
    id: 'type',
    accessor: 'type',
    width: 100,
  },
  {
    Header: 'Data movimentação',
    id: 'createdAt',
    accessor: 'createdAt',
    width: 125,
  },
  {
    Header: 'ID Modelo',
    id: 'product.modelId',
    accessor: 'product.modelId',
    width: 80,
    getProps: numberAlignRight,
  },
  {
    Header: 'Cod. Produto',
    id: 'product.code',
    accessor: 'product.code',
    width: 140,
  },
  {
    Header: 'Descrição',
    id: 'product.description',
    accessor: 'product.description',
    width: 250,
    getProps: textBreakWord,
  },
  {
    Header: 'Usuário',
    id: 'user',
    accessor: 'user',
    width: 135,
  },
  {
    Header: 'Quantidade',
    id: 'appliedQuantity',
    accessor: 'appliedQuantity',
    width: 80,
    getProps: numberAlignRight,
  },
  {
    Header: 'Saldo final',
    id: 'balance',
    accessor: 'balance',
    width: 80,
    getProps: numberAlignRight,
  },
  {
    Header: 'Sistema de Origem',
    id: 'sourceSystem',
    accessor: 'sourceSystem',
    width: 120,
  },
  {
    Header: '',
    id: 'dumb',
    accessor: 'dumb',
    width: 1,
  },
]
